<div [class.dark-theme]="true" class="fix-action-dialog">
    <h2 data-idtest="aigia-login-qr-dialog-t-5Tj" style="font-size: 17px; color: white;" mat-dialog-title>{{content.title}}</h2>
    <div class="spacer"></div>
    <mat-dialog-content fxLayout="column">
        <div data-idtest="aigia-login-qr-dialog-t-9Qb" style="font-size: 15px; color: white;">{{content.description}}</div>
        <div fxLayout="row" fxLayoutAlign="center center">
            <img *ngIf="qr != ''" [src]="qr" style="border-style: solid; border-color: #505050;" fxFlex="234px" fxFlex.lt-sm="100">
        </div>
    </mat-dialog-content>
    <div class="spacer"></div>
    <mat-dialog-actions fxLayout="column">
		<!--<div>{{qr}}</div>-->
        <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
			<button color="warn" mat-dialog-close="" mat-stroked-button><span data-idtest="aigia-login-qr-dialog-t-3Kd" translate>閉じる</span></button>
        </div>
    </mat-dialog-actions>
</div>
